module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-Medium.1cceb2dc.woff2";